import * as React from 'react';
import { Configure, Index, useSortBy, useRefinementList, useRange, useSearchBox, useConfigure } from 'react-instantsearch';
import { FacetId } from '../../../types.js';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';

const VirtualSortBy = ({ items  })=>{
    const parsedItems = React.useMemo(()=>items.map((item)=>({
                value: item.value,
                label: item.labelKey
            })
        )
    , [
        items
    ]);
    useSortBy({
        items: parsedItems
    });
    return null;
};
const VirtualRefinementList = ({ attribute , limit  })=>{
    useRefinementList({
        attribute,
        limit
    });
    return null;
};
const VirtualRange = ({ attribute  })=>{
    useRange({
        attribute
    });
    return null;
};
const VirtualSearchBox = ()=>{
    useSearchBox();
    return null;
};
const VirtualInfinitePagination = ({ pageSize , searchState  })=>{
    var ref;
    useConfigure({
        offset: 0,
        length: searchState === null || searchState === void 0 ? void 0 : (ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.length,
        hitsPerPage: pageSize
    });
    return null;
};
/**
 * VirtualFacets should never render HTML
 */ const VirtualFacets = ()=>{
    const { facets , sortIndices , filters , pageSize , ruleContexts , facetingAfterDistinct , indices , algoliaInstantSearchProps: { searchState , indexName  } ,  } = useAlgoliaConfig();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), indices && indices.length > 0 ? indices.map((name)=>/*#__PURE__*/ React.createElement(Index, {
            indexName: name,
            key: name
        })
    ) : null, sortIndices.length > 0 ? /*#__PURE__*/ React.createElement(VirtualSortBy, {
        items: sortIndices
    }) : null, /*#__PURE__*/ React.createElement(VirtualInfinitePagination, {
        pageSize: pageSize,
        searchState: searchState[indexName]
    }), /*#__PURE__*/ React.createElement(VirtualSearchBox, null), facets.map((facet)=>{
        switch(facet.id){
            case FacetId.price:
                return /*#__PURE__*/ React.createElement(VirtualRange, {
                    key: facet.attribute,
                    attribute: facet.attribute
                });
            default:
                return /*#__PURE__*/ React.createElement(VirtualRefinementList, {
                    key: facet.attribute,
                    attribute: facet.attribute,
                    limit: 100
                });
        }
    }), /*#__PURE__*/ React.createElement(Configure, {
        filters: filters,
        ruleContexts: ruleContexts
    }));
};

export { VirtualFacets as default };
//# sourceMappingURL=VirtualFacets.js.map
